import useSWR from 'swr';

import { apiUrls } from 'services/api-urls';
import { fetcher } from 'services/fetcher';
import { ShippingMethods } from 'types/ShippingMethods';

type ReturnType = {
  methods: ShippingMethods['methods'];
  defaultMethod: ShippingMethods['defaultDeliveryMethod'];
};

export default function useDeliveryMethods(): Partial<ReturnType> {
  const { data: methodsAvailable } = useSWR<ShippingMethods>(
    apiUrls.getCheckoutDelivery(),
    fetcher
  );

  return {
    methods: methodsAvailable?.methods,
    defaultMethod: methodsAvailable?.defaultDeliveryMethod,
  };
}
